import styled, { createGlobalStyle } from "styled-components";

export const ViewDetailsTableWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  border-top: 0.5px solid var(--border-color);
  border-left: 0.5px solid var(--border-color);
`;

export const DetailContainer = styled.div`
  border-right: 0.5px solid var(--border-color);
  border-bottom: 0.5px solid var(--border-color);
  padding: 10px;
`;

export const DetailText = styled.p`
  font-size: 14px;
  overflow-wrap: break-word;
  font-style: italic;

  @media only screen and (max-width: 1023px) {
    font-size: 12px;
  }
`;

export const ExpandIcon = styled.div`
  width: 18px;
  height: 18px;
  color: var(--theme-color-primary);
  border: 1px solid var(--theme-color-primary);
  border-radius: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  margin-top: 5px;

  svg {
    width: 14px;
    height: auto;
    transition: all ease-in-out 0.3s;
  }
`;

export const JsonWrapStyle = createGlobalStyle`
  .react-json-view {
    /* white-space: pre-wrap !important; */
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    background-color: transparent;
    font-size: 13px;
    padding: 10px;
    max-width: 50ch; /* wrap after roughly 40 characters */
  }
`;